import { ChangeDetectionStrategy, Component, inject, model, OnInit } from '@angular/core'
import { CertificateHolderStateService } from '@app/layout/sidebar/services/certificate-holder-state.service'
import { ContentSidebarListViewComponent } from '@app/layout/sidebar/components/content-sidebar-list-view/content-sidebar-list-view.component'
import { ListViewChListItemComponent } from '@app/layout/sidebar/components/listview-ch/list-view-ch-list-item/list-view-ch-list-item.component'

@Component({
  selector: 'albert-listview-ch',
  imports: [
    ContentSidebarListViewComponent,
    ListViewChListItemComponent
  ],
  templateUrl: './list-view-ch.component.html',
  styleUrl: './list-view-ch.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ListViewChComponent implements OnInit {
  public readonly sidebarDrawerVisible = model(false)
  public readonly certificateHolderState = inject(CertificateHolderStateService)
  public readonly itemSize = 102

  public ngOnInit(): void {
    this.certificateHolderState.reload(20).subscribe()
  }
}
